export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export function selectMatchingVideoSource(video) {
	return new Promise((resolve) => {
		if (!video) {
			return;
		}
		const rect = video.getBoundingClientRect();

		const clientWidth = rect.width * window.devicePixelRatio;
		const clientHeight = rect.height * window.devicePixelRatio;
		const clientRatio = clientWidth / clientHeight;

		const videoWidth = video.getAttribute('width');
		const videoHeight = video.getAttribute('height');
		const videoRatio = videoWidth / videoHeight;

		let width = '';
		if (clientRatio > videoRatio) {
			width = clientWidth;
		} else {
			width = clientHeight * videoRatio;
		}

		let matchedSource = null;
		let prevDiff = 999999;

		// Loop over all video sources
		const totalSourceCount = video.children.length;
		let checkedSourcesCount = 0;
		const checkSources = new Promise((resolve, reject) => {
			Array.from(video.children).forEach((source) => {
				// Get source resolution (provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= prevDiff) {
					matchedSource = source;
				}
				prevDiff = currentDiff;

				setTimeout(() => {
					checkedSourcesCount++;
					if (checkedSourcesCount >= totalSourceCount) {
						resolve('Checked All Sources');
					}
				}, 0);
			});
		});

		checkSources.then(() => {
			if (video.src != matchedSource.src) {
				video.pause();
				video.src = matchedSource.src;
				resolve();
			}
		});
	});
}

/**
 *
 * @param {Event} e
 * @param {String} selector
 * @returns {HTMLElement|null}
 */
export function getElementFromEvent(e, selector) {
	if (!e.target) {
		return null;
	}

	const el = e.target?.closest(selector);

	if (!el) {
		return null;
	}

	return el;
}

export function storageAvailable(type) {
	let storage;
	try {
		storage = window[type];
		const x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return (
			e instanceof DOMException &&
			// everything except Firefox
			(e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === 'QuotaExceededError' ||
				// Firefox
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0
		);
	}
}
